'use strict'

import { AppContext } from "@lightspeed-invoicing/core-client/frontend";

const SupportedSettings = {
    ShowShortDescriptionInListing: 'show-short-description-in-listing',
    ShowSKUInPricingTable: 'show-sku-in-pricing-table'
}

class SettingsContainer {
    constructor() {
        this.settings = {}
    }

    async load() {
        return Promise.all(Object.values(SupportedSettings).map(val => {
            return AppContext.getApiClient().get('/default-proposal-options/' + val)
        })).then(res => {
            for (let i in res) {
                this.settings[res[i].attributes.optionKey] = res[i].attributes.value
            }
        })
    }

    get(key) {
        return this.settings[key]
    }

}
const Settings = new SettingsContainer()
export {
    Settings,
    SupportedSettings
};



// WEBPACK FOOTER //
// ./src/settings/account/Settings.jsx